import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { Icon } from '@ohif/ui';
import { useProfile } from './helpers/api/auth/auth';

const PublicRoutes = ({ children }) => {
  const location = useLocation();
  const bypassProfile = location.pathname === '/callback' || location.pathname === '/2fa-setup' || location.pathname === '/google-2fa' || location.pathname === '/force-password-change';
  const me = useProfile({ retry: 0, enabled: !bypassProfile });

  if (!bypassProfile && me.isLoading && !me.isFetched) {
    return (
      <div className="fixed inset-0 z-[100] flex h-full w-full flex-col items-center justify-center bg-white">
        <div className="loader">
          <Icon name={'deepechoLogo2'} />
        </div>
      </div>
    );
  }

  if (!bypassProfile && me.data && location.pathname !== '/') {
    return <Navigate to="/home" />;
  }

  return children;
};

export default PublicRoutes;
